module.exports = __webpack_public_path__ + "img/beer_id-69.b93e3e09.png";